import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--gray-02);
`;

type Props = {
  children: React.ReactNode;
};

export const BaseLayout: React.FC<Props> = observer(({ children }) => {
  return <Container>{children}</Container>;
});
